import React from 'react';
import { Row, Col, Modal, Form, Image, Button, FormGroup } from 'react-bootstrap';

import { formatCurrency } from '../../utils/helper';

export const InfoField = ({ label, value, colClass = 'col-12 col-md-4', children }) => {
    const fieldId = label ? label.toLowerCase().trim().replace(/\s+/g, '-') : 'field';

    if (children) {
        return <dl className={`${colClass} details-list`}>{children}</dl>;
    }

    if (!value && value !== 0) return null;

    return (
        <dl className={`${colClass} details-list`}>
            <FormGroup controlId={fieldId}>
                <Form.Label>{label}</Form.Label>
                <Form.Control type="text" value={value} readOnly />
            </FormGroup>
        </dl>
    );
};

export const SectionCard = ({ title, children, settings, minHeight, className = '' }) => (
    <div className={`w-100 payment-form-main ${className}`}>
        <div className="payment-form-desc-main" style={{ backgroundColor: settings.mainColor, minHeight: minHeight }}>
            <Form.Label className="text-uppercase payment-form-headding mb-2" style={{ color: settings.textColor }}>
                {title}
            </Form.Label>
            {children}
        </div>
    </div>
);

export const DataColumn = ({ label, value, colProps, prefix = '', show = true }) => {
    if (!show) return null;
    return (
        <Col {...colProps}>
            <h4 className="booking-qty">
                {label}
                <h5 className="list-content">
                    {prefix}
                    {value}
                </h5>
            </h4>
        </Col>
    );
};

export const PriceRow = ({ label, value, settings, show = true }) => {
    if (!show) return null;
    return (
        <div className="info-wrapper-2 info-wrapper">
            <span className="text-uppercase title-text" style={{ color: settings.textColor }}>
                {label}
            </span>
            <span className="total-text">
                <p>${formatCurrency(value)}</p>
            </span>
        </div>
    );
};

export const InfoRow = ({ label, value, settings, show = true }) => {
    if (!show) return null;
    return (
        <div className="info-wrapper-2 info-wrapper">
            <span className="text-uppercase title-text" style={{ color: settings.textColor }}>
                {label}
            </span>
            <span className="total-text">
                <p>{value}</p>
            </span>
        </div>
    );
};

export const ListVehicles = ({ price, vehicleType: description, taxDescription, salesTax, documentTypeID }) => (
    <Col xs={12} className="booking-details p-0">
        <Row>
            <DataColumn colProps={{ lg: 4, md: 4, sm: 8, xs: 12 }} value={description} />
            <DataColumn
                show={documentTypeID == 1}
                colProps={{ lg: 2, md: 2, sm: 4, xs: 12 }}
                label="Vehicle Price:"
                value={price ? formatCurrency(price) : '0.00'}
                prefix="$"
            />
            {salesTax && documentTypeID == 1 && (
                <>
                    <DataColumn colProps={{ lg: 4, md: 4, sm: 8, xs: 12 }} label="Tax Type:" value={taxDescription} />
                    <DataColumn
                        colProps={{ lg: 2, md: 2, sm: 4, xs: 12 }}
                        label="Tax: "
                        value={salesTax ? formatCurrency(salesTax) : '0.00'}
                        prefix="$"
                    />
                </>
            )}
        </Row>
    </Col>
);

export const ListAddons = ({ price, quantity, description, taxDescription, salesTax }) => (
    <Col xs={12} className="booking-details p-0">
        <Row>
            <DataColumn colProps={{ lg: 3, md: 6, sm: 8, xs: 12 }} value={description} />
            <DataColumn colProps={{ lg: 3, md: 2, sm: 4, xs: 12 }} value={quantity || 0} />
            <DataColumn
                colProps={{ lg: 2, md: 2, sm: 4, xs: 12 }}
                label="Addon Price:"
                value={price ? formatCurrency(price) : '0.00'}
                prefix="$"
            />
            {salesTax && (
                <>
                    <DataColumn colProps={{ lg: 3, md: 6, sm: 4, xs: 12 }} label="Tax Type:" value={taxDescription} />
                    <DataColumn
                        colProps={{ lg: 1, md: 4, sm: 4, xs: 12 }}
                        label="Tax: "
                        value={salesTax ? formatCurrency(salesTax) : '0.00'}
                        prefix="$"
                    />
                </>
            )}
        </Row>
    </Col>
);

export const ListAmenities = ({ description }) => (
    <Col xs={12} className="booking-details p-0">
        <Row>
            <DataColumn colProps={{ lg: 3, md: 6, sm: 8, xs: 12 }} value={description} />
        </Row>
    </Col>
);

export const VehicleOnSite = ({ arrivalTime, destinationAddress }) => (
    <Col xs={12} className="p-0">
        <div className="booking-details">
            <div className="vehicle-box-info">
                <div className="col-3 p-0">
                    <p className="booking-qty">
                        <span className="text-uppercase">{arrivalTime}</span>
                    </p>
                </div>
                <div className="col-9 p-0">
                    <p className="booking-qty">
                        <span>
                            <b>Vehicle On Site at </b> {destinationAddress}
                        </span>
                    </p>
                </div>
            </div>
        </div>
    </Col>
);

export const ListSegments = ({ departureTime, arrivalTime, startAddress, destinationAddress }) => (
    <Col xs={12} className="p-0">
        <div className="booking-details">
            <div className="vehicle-box-info">
                <div className="col-3 p-0">
                    <p className="booking-qty">
                        <span className="text-uppercase">{departureTime}</span>
                        <span className="text-uppercase">{arrivalTime}</span>
                    </p>
                </div>
                <div className="col-9 p-0">
                    <p className="booking-qty">
                        <span>
                            <b>DEPART FROM</b> {startAddress}
                        </span>
                        <span>
                            <b>ARRIVE AT </b> {destinationAddress}
                        </span>
                    </p>
                </div>
            </div>
        </div>
    </Col>
);

export const ListPayments = ({ name, amount, text, isInvoiced }) => (
    <Col xs={12} className="booking-details p-0">
        <Row>
            <DataColumn colProps={{ lg: 4, md: 4, sm: 4, xs: 12 }} value={name} />
            <DataColumn
                show={!isInvoiced}
                colProps={{ lg: 4, md: 4, sm: 4, xs: 12 }}
                value={amount ? formatCurrency(amount) : '0.00'}
                prefix="$"
            />
            <DataColumn colProps={{ lg: 4, md: 4, sm: 4, xs: 12 }} value={isInvoiced ? 'INVOICED' : text} />
        </Row>
    </Col>
);

export const CustomModal = ({ show, onHide, settings, onSubmit, loading, register, type = 'Signature' }) => {
    const title = type === 'Signature' ? 'ACCEPT THIS BOOKING' : 'CONFIRM DETAILS';
    const label = type === 'Signature' ? 'TYPE YOUR NAME HERE TO ACCEPT' : 'TYPE YOUR EMAIL HERE TO CONFIRM';
    const showLabel = type === 'Signature' ? true : false;
    const icon = type === 'Signature' ? 'fas fa-edit' : 'fas fa-user';
    const buttonLabel = type === 'Signature' ? 'Accept & Continue' : 'Confirm & Continue';
    return (
        <Modal
            className="rounded warning-modal custom-modal"
            animation={false}
            size="lg"
            show={show}
            onHide={onHide}
            centered
        >
            <Modal.Header className="header-box portal-text" style={{ backgroundColor: settings.sectionColor }}>
                <Modal.Title>
                    <i className={icon} style={{ fontSize: '30px', paddingLeft: '10px' }} />
                    <span className="accept-title pl-4" style={{ fontWeight: '800' }}>
                        {title}
                    </span>
                </Modal.Title>
                <i className="fas fa-times-circle portal-text closeButton" onClick={onHide} />
            </Modal.Header>
            <Modal.Body className="model-paragraph">
                {showLabel && (
                    <div className="body-content" style={{ fontWeight: '800' }}>
                        {settings.bookingSignatureInstructions}
                    </div>
                )}
                <Row>
                    <Col xs={6}>
                        <FormGroup>
                            <Form.Label className="modal-label" style={{ fontWeight: '800' }}>
                                {label}
                            </Form.Label>
                            <Form.Control type="text" id="name" {...register('name', { required: true })} />
                        </FormGroup>
                    </Col>
                </Row>
                <div className="agree-btn">
                    <Button
                        className="m-1"
                        style={{
                            backgroundColor: loading ? '#646262' : settings.buttonColor,
                            borderColor: 'transparent',
                        }}
                        onClick={onSubmit}
                        disabled={loading}
                    >
                        {buttonLabel}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export const ConfirmationHeader = ({ tripSetting, bookingDisplayId }) => {
    return (
        <div
            className="top-header-box d-flex justify-content-between align-items-center"
            style={{ backgroundColor: tripSetting.sectionColor }}
        >
            <div className="booking-title portal-text">
                {tripSetting.companyLogoUrl && (
                    <Image src={tripSetting.companyLogoUrl} className="images-logo m-0 p-0" />
                )}
                <div
                    className="d-flex align-items-center font-weight-bold booking-heading"
                    style={{ color: tripSetting.textColor }}
                >{`BOOKING ${bookingDisplayId}`}</div>
            </div>
            <div className="btn portal-text rounded-pill no-point" style={{ backgroundColor: tripSetting.buttonColor }}>
                <i className="fas fa-check-square mr-2"></i>CONFIRM BOOKING
            </div>
        </div>
    );
};
